// Simple logger wrapper to centralize logging and suppress info-level logs in production.
const isProd = typeof process !== 'undefined' && process.env.NODE_ENV === 'production';

export const info = (...args: unknown[]) => {
  if (!isProd) {
    // preserve console formatting
    console.info(...args);
  }
};

export const warn = (...args: unknown[]) => {
  console.warn(...args);
};

export const error = (...args: unknown[]) => {
  console.error(...args);
};

export default {
  info,
  warn,
  error,
};
